// Hardcoded print-method payloads streamed to the customizer in discovery mode.
//
// These are sample/sandbox configurations that the backoffice forces onto the previewed product over
// postMessage (DiscoveryModeUpdate, category 'printing'). They mirror the raw print-type shape the
// customizer API returns, so the customizer can map and inject them like any real print method.
//
// Entries are keyed by the DiscoveryModePanel item id — the panel only wires a button when its id is a key
// of DISCOVERY_PRINTING_PAYLOADS, so renaming a method means renaming the key and the panel id together.

export const WOOD_PRINTING_PRINT_METHOD = {
    printTypeID: 1000147,
    name: 'Wood Printing',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1000124,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1000124,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: 0,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#287fb9',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: false,
        canPrintShadows: true,
        disableImageRotateUpload: null,
        disableImageRotateCliparts: null,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: false,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 4,
        canStretchImages: false,
        canStretchTexts: false,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: {
        type: 2,
        blendMode: 'hard-light',
        enhanceBlendMode: false,
        opacity: 0.9,
        textColor: null,
        imageEffectTypeName: 'None',
        imageEffectParameterValues: []
    },
    outputDesignEffect: null,
    maxColors: null,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: [],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};

// Full-color digital print: the most permissive sample method. On top of the DTG defaults it also allows
// filling text with an uploaded image and with a gallery/clipart image (allowImageUploadTextColors /
// allowImageGalleryTextColors); gradient text fill, shadows, stroke, and image/text stretch are already on.
export const DIGITAL_PRINT_PRINT_METHOD = {
    printTypeID: 1090917,
    name: 'Digital Print',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1100880,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1100880,
        disableTextColors: false,
        allowGradientTextColors: true,
        allowImageUploadTextColors: true,
        allowImageGalleryTextColors: true,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: 0,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#000000',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: true,
        canPrintShadows: true,
        disableImageRotateUpload: false,
        disableImageRotateCliparts: false,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 4,
        canStretchImages: true,
        canStretchTexts: true,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    maxColors: null,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: [],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: {
        printTypeID: 1090917,
        presets: [5, 1, 4, 6, 2, 3, 7, 8],
        isImageEnabled: true,
        isTextEnabled: true,
        allowSpacingChange: true,
        allowOffsetChange: true
    },
    backgroundRemoverSettings: null
};

// Same base as Digital Print, with repeated patterns as the point of the method: customers turn text and
// images into a repeating pattern and adjust its spacing/offset. Spread rather than copied — the source
// payload was byte-identical to Digital Print apart from the ids and patternSettings below.
//
// NOTE: the source had `presets: []` with a comment claiming empty meant "all built-in pattern styles". It
// does not — an empty list offers the customer NO pattern style, which is why the method never worked. It
// carries the same explicit preset list and rules as every other discovery method that enables patterns.
export const REPEATED_PATTERNS_PRINT_METHOD = {
    ...DIGITAL_PRINT_PRINT_METHOD,
    printTypeID: 1090919,
    name: 'Repeated patterns',
    printTypeRestrictionsID: 1100882,
    printTypeRestrictions: {
        ...DIGITAL_PRINT_PRINT_METHOD.printTypeRestrictions,
        partPrintTypeRestrictionID: 1100882
    },
    patternSettings: {
        printTypeID: 1090919,
        presets: [5, 1, 4, 6, 2, 3, 7, 8],
        isImageEnabled: true,
        isTextEnabled: true,
        allowSpacingChange: true,
        allowOffsetChange: true
    }
};

// AI Vectorizer and AI Background Remover are PRINT-TYPE SETTINGS, not standalone tools: the backoffice edits
// both on the print-method page (see printType.tsx / printingMethodEditor.tsx), and the customizer reads them
// off the current print type (see the customizer's dataFetcher.mappers — vectorizeSettings /
// backgroundRemoverSettings). That is why they live here rather than in discoveryTools.ts: streaming a print
// type that already carries the setting lights each feature up through its REAL code path, with no
// discovery-specific forcing in the customizer at all.
//
// Both follow Repeated Patterns' shape — Digital Print plus the one field group that is the point of the
// method — and drop Digital Print's `patternSettings`, which has nothing to do with what they demo and would
// put an unexplained Patterns control in the sandbox.

// Turns on the upload-time vectorize dialog: the customer uploads a raster image and is offered a clean
// vector version of it.
//
// `vectorizeOption: 1` (= RASTER) keeps the "keep original" choice in the dialog, which is both the better
// demo and the cheaper one — declining skips the vectorize call entirely (see the customizer's
// useProcessImageUpload: a declined credit confirmation sets shouldKeepRasterImage).
//
// `createVectorizePreview` stays FALSE deliberately. With it on, the dialog renders a preview and the real
// vectorization runs AGAIN on confirm (the customizer flips `alreadyVectorized` off in preview mode), so a
// single accepted image can bill twice. Off, the dialog's result is the final image — one call, one credit.
//
// NOTE: this only lights up for accounts that own VECTORIZE credits. The customizer's mapper gates
// vectorizeSettings on `servicesEnabled.VECTORIZE`, so `enableVectorize` alone is inert without them — which
// is why the pill hides itself on accounts with no credits (see the customizer's
// useDiscoveryHiddenToolsNotifier). Vectorizing here spends REAL credits, exactly as it does live.
export const AI_VECTORIZER_PRINT_METHOD = {
    ...DIGITAL_PRINT_PRINT_METHOD,
    printTypeID: 1090920,
    name: 'AI Vectorizer',
    printTypeRestrictionsID: 1100883,
    printTypeRestrictions: {
        ...DIGITAL_PRINT_PRINT_METHOD.printTypeRestrictions,
        partPrintTypeRestrictionID: 1100883,
        enableVectorize: true,
        showVectorizeModal: true,
        vectorizeOption: 1,
        createVectorizePreview: false
    },
    patternSettings: null
};

// Turns on AI background removal, in both places the print type can offer it:
//  - `isUploadEnabled` — the dialog fires mid-upload, offering the cutout before the image lands on canvas;
//  - `isEditEnabled` — "remove background" stays available on an image already placed on the canvas.
// `isHiddenMode` MUST stay false: hidden mode strips the background silently with no dialog, so the merchant
// would see the feature's result without ever seeing the feature (see the customizer's useProcessImageUpload —
// hasBackgroundModal requires !hiddenMode).
//
// `removerVersion: null` means "no version specified", so the backend picks its own default. The alternative
// is the LEGACY remover, which is only meaningful for accounts migrating off it — not something to demo.
//
// Unlike the vectorizer this has no credit gate anywhere on the frontend: background removal is the
// BACKGROUND_REMOVE subscription add-on, not a consumable pool, and nothing checks for it. So the pill is
// always visible and every use is a real removal call.
export const AI_BACKGROUND_REMOVER_PRINT_METHOD = {
    ...DIGITAL_PRINT_PRINT_METHOD,
    printTypeID: 1090921,
    name: 'AI Background Remover',
    printTypeRestrictionsID: 1100884,
    printTypeRestrictions: {
        ...DIGITAL_PRINT_PRINT_METHOD.printTypeRestrictions,
        partPrintTypeRestrictionID: 1100884
    },
    patternSettings: null,
    backgroundRemoverSettings: {
        isUploadEnabled: true,
        isHiddenMode: false,
        isEditEnabled: true,
        removerVersion: null
    }
};

// Same base as Digital Print, but the colour choice is limited to a predefined palette of 50 swatches
// (paletteColors). maxColors stays null — the restriction is the palette itself, not a per-design count cap.
export const LIMITED_COLOR_PALETTE_PRINT_METHOD = {
    printTypeID: 1090918,
    name: 'Limited Color Palette',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1100881,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1100881,
        disableTextColors: false,
        allowGradientTextColors: true,
        allowImageUploadTextColors: true,
        allowImageGalleryTextColors: true,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: 0,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#000000',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: true,
        canPrintShadows: true,
        disableImageRotateUpload: false,
        disableImageRotateCliparts: false,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 4,
        canStretchImages: true,
        canStretchTexts: true,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    maxColors: null,
    paletteID: null,
    paletteTypeID: null,
    // Predefined palette of 50 swatches the customer is limited to.
    paletteColors: [
        '#000000',
        '#404040',
        '#808080',
        '#bfbfbf',
        '#ffffff',
        '#7f0000',
        '#b30000',
        '#e60000',
        '#ff3333',
        '#ff9999',
        '#7f3f00',
        '#b35900',
        '#e67300',
        '#ff8c1a',
        '#ffc180',
        '#7f7f00',
        '#b3b300',
        '#e6e600',
        '#ffff33',
        '#ffff99',
        '#007f00',
        '#00b300',
        '#00e600',
        '#33ff33',
        '#99ff99',
        '#007f7f',
        '#00b3b3',
        '#00e6e6',
        '#33ffff',
        '#99ffff',
        '#00007f',
        '#0000b3',
        '#0000e6',
        '#3333ff',
        '#9999ff',
        '#3f007f',
        '#5900b3',
        '#7300e6',
        '#8c1aff',
        '#c180ff',
        '#7f007f',
        '#b300b3',
        '#e600e6',
        '#ff33ff',
        '#ff99ff',
        '#4c2600',
        '#663300',
        '#994d00',
        '#cc6600',
        '#8b4513'
    ],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: {
        printTypeID: 1090918,
        presets: [5, 1, 4, 6, 2, 3, 7, 8],
        isImageEnabled: true,
        isTextEnabled: true,
        allowSpacingChange: true,
        allowOffsetChange: true
    },
    backgroundRemoverSettings: null
};

export const PIXELATION_PRINT_METHOD = {
    printTypeID: 1090915,
    name: 'Pixelation',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1100878,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1100878,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: true,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: 0,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#287fb9',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: false,
        canPrintShadows: true,
        disableImageRotateUpload: false,
        disableImageRotateCliparts: false,
        allowImageResizeUpload: false,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: false,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 2,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: false,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 4,
        canStretchImages: false,
        canStretchTexts: false,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: {
        type: 3,
        blendMode: 'normal',
        enhanceBlendMode: false,
        opacity: 100,
        textColor: null,
        imageEffectTypeName: 'pixelation',
        imageEffectParameterValues: [{ name: 'pixelationLevel', value: '19' }]
    },
    outputDesignEffect: {
        type: 3,
        blendMode: 'normal',
        enhanceBlendMode: false,
        opacity: 100,
        textColor: null,
        imageEffectTypeName: 'pixelation',
        imageEffectParameterValues: [{ name: 'pixelationLevel', value: '19' }]
    },
    maxColors: null,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: [],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};

export const STEEL_ENGRAVING_PRINT_METHOD = {
    printTypeID: 4248,
    name: 'Steel Engraving',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 681,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 681,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: false,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: null,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: false,
        allowItalic: false,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#287fb9',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: -50,
        maxLetterSpacing: 50,
        allowLineSpacing: true,
        minLineSpacing: -50,
        maxLineSpacing: 50,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: 15,
        maxFontSize: 750,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: true,
        canPrintShadows: true,
        disableImageRotateUpload: null,
        disableImageRotateCliparts: null,
        allowImageResizeUpload: null,
        minImageResizeUpload: null,
        maxImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minImageResizeCliparts: null,
        maxImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: 1,
        maxShadowBlur: null,
        minShadowDistance: 1,
        maxShadowDistance: null,
        minShadowAngle: 1,
        maxShadowAngle: null,
        defaultFontSize: 45,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 1,
        maxTextStrokeWidth: 4,
        canStretchImages: true,
        canStretchTexts: true,
        embeddedPdf: false
    },
    printTypeFonts: [
        { printTypeID: 4248, fontFamilyID: 46, fontFamilyName: 'Cairo' },
        { printTypeID: 4248, fontFamilyID: 47, fontFamilyName: 'Fondamento' },
        { printTypeID: 4248, fontFamilyID: 51, fontFamilyName: 'Mada' },
        { printTypeID: 4248, fontFamilyID: 56, fontFamilyName: 'Adamina' },
        { printTypeID: 4248, fontFamilyID: 64, fontFamilyName: 'Condiment' },
        { printTypeID: 4248, fontFamilyID: 110038, fontFamilyName: 'Osake' }
    ],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: {
        type: 1,
        blendMode: 'normal',
        enhanceBlendMode: true,
        opacity: 0.7,
        textColor: null,
        imageEffectTypeName: 'greyscale',
        imageEffectParameterValues: [
            { name: 'Halftone', value: 'dithering' },
            { name: 'Overlay color', value: '#999999' }
        ]
    },
    outputDesignEffect: {
        type: 1,
        blendMode: 'normal',
        enhanceBlendMode: false,
        opacity: 100,
        textColor: null,
        imageEffectTypeName: 'None',
        imageEffectParameterValues: []
    },
    maxColors: null,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: [],
    splitColorFiles: false,
    layeredPdf: false,
    // Repeated patterns are deliberately OFF for all three engraving methods (wood/glass inherit this null).
    patternSettings: null,
    backgroundRemoverSettings: null,
    // Discovery-only marker (not part of the print-type API shape): the create form auto-selects this
    // engraving effect preset template by name (see the effect auto-select in effects.tsx).
    discoveryEffectTemplateName: 'Engraving on light steel 1'
};

// Wood engraving reuses the Steel Engraving base; the effect preset template, the preview overlay colour
// (and name/id) differ.
export const WOOD_ENGRAVING_PRINT_METHOD = {
    ...STEEL_ENGRAVING_PRINT_METHOD,
    printTypeID: 4249,
    name: 'Wood Engraving',
    // Burnt wood reads brown rather than steel's grey #999999. Opacity is deliberately NOT overridden — it
    // inherits steel's 0.7 (glass drops to 0.4 for a pale frost, wood should not).
    previewDesignEffect: {
        ...STEEL_ENGRAVING_PRINT_METHOD.previewDesignEffect,
        imageEffectParameterValues: [
            { name: 'Halftone', value: 'dithering' },
            { name: 'Overlay color', value: '#a34a00' }
        ]
    },
    discoveryEffectTemplateName: 'Engraving on wood 1'
};

// Glass engraving reuses the Steel Engraving base; the effect preset template, the preview overlay colour
// (and name/id) differ.
export const GLASS_ENGRAVING_PRINT_METHOD = {
    ...STEEL_ENGRAVING_PRINT_METHOD,
    printTypeID: 4250,
    name: 'Glass Engraving',
    // Spread (not shared by reference) so this stays independent of the steel base: etched glass reads as a
    // pale frost, so the overlay is a much lighter grey than steel's #999999. Everything else is inherited.
    previewDesignEffect: {
        ...STEEL_ENGRAVING_PRINT_METHOD.previewDesignEffect,
        opacity: 0.4,
        imageEffectParameterValues: [
            { name: 'Halftone', value: 'dithering' },
            { name: 'Overlay color', value: '#dddddd' }
        ]
    },
    discoveryEffectTemplateName: 'engraving on glass 1'
};

// Standard house plastisol ink chart (42 stock inks) for Screenprinting. Screenprinting is a spot-colour
// process: the shop stocks these inks, so the customer picks FROM them and maxColors (5) caps how many
// screens one design can use. Order follows the printed chart (neutrals -> browns -> reds/pinks ->
// oranges/yellows -> greens -> blues -> teals/purples); hexes sampled from the chart swatches.
//
// `name` renders as the swatch's label through the palette the customizer's discovery palette registrar
// injects (see `paletteColorNames` on the method below). Deliberately NO `spotColorName`: these are house
// inks matched to Pantone (refs kept in the trailing comments for the shop, not shown to the customer), and
// showing PANTONE codes here would blur the line with the dedicated Pantone print method.
const HOUSE_PLASTISOL_INKS = [
    { hex: '#000000', name: 'Black' },
    { hex: '#ffffff', name: 'White' },
    { hex: '#a1a6a5', name: 'Lt Gray' }, // 422
    { hex: '#6b7070', name: 'Gray' }, // 424
    { hex: '#4d4e52', name: 'Cool Gray' }, // Cool Gray 11
    { hex: '#efc083', name: 'Tan' }, // 156
    { hex: '#d6c299', name: 'Khaki' }, // 467
    { hex: '#d9aa04', name: 'Gold' }, // 110
    { hex: '#a07f06', name: 'Old Gold' }, // 126
    { hex: '#955d37', name: 'Lt Brown' }, // 4635
    { hex: '#623317', name: 'Brown' }, // 469
    { hex: '#562912', name: 'Dk Brown' }, // 1545
    { hex: '#dc2619', name: 'Brick Red' }, // 485
    { hex: '#a52c34', name: 'Maroon' }, // 1807
    { hex: '#ce022c', name: 'Red' }, // 186
    { hex: '#ad132b', name: 'Cardinal' }, // 187
    { hex: '#fcbcca', name: 'Lt Pink' }, // 182
    { hex: '#fc7cb6', name: 'Pink' }, // 211
    { hex: '#e91775', name: 'Dk Pink' }, // 213
    { hex: '#e038ae', name: 'Magenta' }, // 239
    { hex: '#ffb851', name: 'Lt Orange' }, // 1365
    { hex: '#fe5900', name: 'Orange' }, // Orange 021
    { hex: '#d64627', name: 'Dk Orange' }, // 173
    { hex: '#f3ec7a', name: 'Lemon' }, // 100
    { hex: '#ffe102', name: 'Yellow' }, // Yellow
    { hex: '#a5e6bc', name: 'Lt Green' }, // 351
    { hex: '#bed902', name: 'Olive' }, // 382
    { hex: '#55a719', name: 'Green' }, // 369
    { hex: '#02af42', name: 'Kelly Green' }, // 354
    { hex: '#1f5734', name: 'Dk Green' }, // 357
    { hex: '#012f5b', name: 'Navy' }, // 540
    { hex: '#002477', name: 'Dk Blue' }, // 280
    { hex: '#0163bf', name: 'Blue' }, // 300
    { hex: '#0236a5', name: 'Royal' }, // 286
    { hex: '#9fceec', name: 'Lt Blue' }, // 291
    { hex: '#00bae3', name: 'Turquoise' }, // 306
    { hex: '#22d6ca', name: 'Tiffany' }, // 3255
    { hex: '#08a29e', name: 'Teal' }, // 3272
    { hex: '#02737f', name: 'Shark Teal' }, // 322
    { hex: '#5b1a65', name: 'Dk Purple' }, // 2623
    { hex: '#50219b', name: 'Purple' }, // 267
    { hex: '#a67eca', name: 'Lt Purple' } // 2577
];

export const SCREEN_PRINTING_PRINT_METHOD = {
    printTypeID: 4208,
    name: 'Screenprinting',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 652,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 652,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: false,
            // Screenprinting is vector/spot-color art only — block all raster upload formats (JPG was the
            // last one still allowed; PNG / PDF-with-raster / Facebook / Instagram are already off). Vector
            // uploads (SVG / EPS / AI / vector PDF) stay enabled.
            isJpgAllowed: false,
            isPngAllowed: false,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: false,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: false,
            isInstagramAllowed: false,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: null,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: false,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        defaultColor: '#279767',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: true,
        canPrintShadows: true,
        disableImageRotateUpload: false,
        disableImageRotateCliparts: true,
        allowImageResizeUpload: true,
        minImageResizeUpload: 30,
        maxImageResizeUpload: 70,
        allowImageResizeCliparts: true,
        minImageResizeCliparts: 20,
        maxImageResizeCliparts: 100,
        defaultShadowColor: '#279767',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 5,
        canStretchImages: false,
        canStretchTexts: false,
        embeddedPdf: false
    },
    printTypeFonts: [
        { printTypeID: 4208, fontFamilyID: 41, fontFamilyName: 'Leckerli One' },
        { printTypeID: 4208, fontFamilyID: 42, fontFamilyName: 'Amatic SC' },
        { printTypeID: 4208, fontFamilyID: 43, fontFamilyName: 'Kaushan Script' },
        { printTypeID: 4208, fontFamilyID: 44, fontFamilyName: 'Amiri' },
        { printTypeID: 4208, fontFamilyID: 45, fontFamilyName: 'Ramaraja' },
        { printTypeID: 4208, fontFamilyID: 46, fontFamilyName: 'Cairo' },
        { printTypeID: 4208, fontFamilyID: 47, fontFamilyName: 'Fondamento' },
        { printTypeID: 4208, fontFamilyID: 48, fontFamilyName: 'Gloria Hallelujah' },
        { printTypeID: 4208, fontFamilyID: 49, fontFamilyName: 'Indie Flower' },
        { printTypeID: 4208, fontFamilyID: 50, fontFamilyName: 'Arizonia' },
        { printTypeID: 4208, fontFamilyID: 51, fontFamilyName: 'Mada' },
        { printTypeID: 4208, fontFamilyID: 52, fontFamilyName: 'IM FELL English' },
        { printTypeID: 4208, fontFamilyID: 53, fontFamilyName: 'Berkshire Swash' },
        { printTypeID: 4208, fontFamilyID: 54, fontFamilyName: 'Permanent Marker' },
        { printTypeID: 4208, fontFamilyID: 55, fontFamilyName: 'Damion' },
        { printTypeID: 4208, fontFamilyID: 56, fontFamilyName: 'Adamina' },
        { printTypeID: 4208, fontFamilyID: 57, fontFamilyName: 'Rock Salt' },
        { printTypeID: 4208, fontFamilyID: 58, fontFamilyName: 'Pacifico' },
        { printTypeID: 4208, fontFamilyID: 59, fontFamilyName: 'Aladin' },
        { printTypeID: 4208, fontFamilyID: 60, fontFamilyName: 'Patrick Hand' },
        { printTypeID: 4208, fontFamilyID: 61, fontFamilyName: 'Cookie' },
        { printTypeID: 4208, fontFamilyID: 62, fontFamilyName: 'EB Garamond' },
        { printTypeID: 4208, fontFamilyID: 63, fontFamilyName: 'Merienda One' },
        { printTypeID: 4208, fontFamilyID: 64, fontFamilyName: 'Condiment' },
        { printTypeID: 4208, fontFamilyID: 291, fontFamilyName: 'Noto Sans' },
        { printTypeID: 4208, fontFamilyID: 2239, fontFamilyName: 'Alegreya Sans' },
        { printTypeID: 4208, fontFamilyID: 100009, fontFamilyName: 'Horrendous' },
        { printTypeID: 4208, fontFamilyID: 100016, fontFamilyName: 'Sour Gummy Expanded' },
        { printTypeID: 4208, fontFamilyID: 100023, fontFamilyName: 'cave' },
        { printTypeID: 4208, fontFamilyID: 110036, fontFamilyName: 'Dancing Script Medium_custom' },
        { printTypeID: 4208, fontFamilyID: 110037, fontFamilyName: 'Dancing Script_custom' }
    ],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    maxColors: 5,
    // Keep null: discovery PMs are self-contained — colours come from paletteColors only. A real paletteID
    // would make the customizer fetch that account's palette and intersect it with paletteColors (the
    // customizer also strips it at intake; see useDiscoveryModeUpdater). Source example's id was 273.
    paletteID: null,
    paletteTypeID: null,
    // Both derived from HOUSE_PLASTISOL_INKS so the hexes can never drift apart: `paletteColors` is the
    // real print-type field (drives recolour + which swatches are selectable), `paletteColorNames` is a
    // discovery-only extra the customizer's palette registrar reads to label those swatches.
    paletteColors: HOUSE_PLASTISOL_INKS.map((ink) => ink.hex),
    paletteColorNames: HOUSE_PLASTISOL_INKS,
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};

export const MONOCHROME_PRINT_METHOD = {
    printTypeID: 1060705,
    name: 'Monochromie',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1070674,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1070674,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: true,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: false,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: null,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#331478',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: false,
        canPrintShadows: true,
        disableImageRotateUpload: null,
        disableImageRotateCliparts: null,
        allowImageResizeUpload: false,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: false,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#331478',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 2,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: false,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 4,
        canStretchImages: false,
        canStretchTexts: false,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    // Cap the design at a single colour but let the customer pick it freely — no predefined palette.
    // maxColors enforces the limit; paletteID/paletteTypeID/paletteColors stay empty so no swatch set is imposed.
    maxColors: 1,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: [],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: {
        printTypeID: 1060705,
        presets: [5, 1, 4, 6, 2, 3, 7, 8],
        isImageEnabled: true,
        isTextEnabled: true,
        allowSpacingChange: true,
        allowOffsetChange: true
    },
    backgroundRemoverSettings: null
};

// Sample Pantone palette streamed alongside the Pantone print method below. Pantone swatches are NOT
// part of the print-type shape: the customizer reads them from `customizerInfo.pantoneColors` (filled
// by the `customizerinfo` endpoint) and only shows them when that list is non-empty AND the active
// print type has `pantoneEnabled`. A sandbox account's list is usually empty, so we hardcode a sample
// set here and the customizer's discovery Pantone registrar lands it into `customizerInfo.pantoneColors`.
// Shape mirrors the endpoint's entries: { id, name, pantonecode, rgbhexcode }.
// Ordered by tone: chromatic colors around the hue wheel (red -> orange -> yellow -> green -> teal ->
// blue -> purple -> magenta), then neutrals grouped at the end from dark to light.
const PANTONE_SAMPLE_COLORS = [
    { id: 1, name: 'Wine', pantonecode: 'PANTONE 7421 C', rgbhexcode: '#651D32' },
    { id: 2, name: 'Rose', pantonecode: 'PANTONE 199 C', rgbhexcode: '#D50032' },
    { id: 3, name: 'Crimson', pantonecode: 'PANTONE 200 C', rgbhexcode: '#BA0C2F' },
    { id: 4, name: 'Bright Red', pantonecode: 'PANTONE 185 C', rgbhexcode: '#E4002B' },
    { id: 5, name: 'Cardinal Red', pantonecode: 'PANTONE 186 C', rgbhexcode: '#C8102E' },
    { id: 6, name: 'Burgundy', pantonecode: 'PANTONE 187 C', rgbhexcode: '#A6192E' },
    { id: 7, name: 'Scarlet', pantonecode: 'PANTONE 1795 C', rgbhexcode: '#D22630' },
    { id: 8, name: 'Coral', pantonecode: 'PANTONE 711 C', rgbhexcode: '#CB333B' },
    { id: 9, name: 'Salmon', pantonecode: 'PANTONE 178 C', rgbhexcode: '#FF585D' },
    { id: 10, name: 'Tangerine', pantonecode: 'PANTONE 1655 C', rgbhexcode: '#FC4C02' },
    { id: 11, name: 'Bright Orange', pantonecode: 'PANTONE 021 C', rgbhexcode: '#FE5000' },
    { id: 12, name: 'Pumpkin', pantonecode: 'PANTONE 165 C', rgbhexcode: '#FF671F' },
    { id: 13, name: 'Apricot', pantonecode: 'PANTONE 1505 C', rgbhexcode: '#FF6900' },
    { id: 14, name: 'Amber', pantonecode: 'PANTONE 7406 C', rgbhexcode: '#F2A900' },
    { id: 15, name: 'Mustard', pantonecode: 'PANTONE 7555 C', rgbhexcode: '#D29F13' },
    { id: 16, name: 'Honey', pantonecode: 'PANTONE 7548 C', rgbhexcode: '#FFC600' },
    { id: 17, name: 'Marigold', pantonecode: 'PANTONE 116 C', rgbhexcode: '#FFCD00' },
    { id: 18, name: 'Golden Yellow', pantonecode: 'PANTONE 109 C', rgbhexcode: '#FFD100' },
    { id: 19, name: 'Sunshine Yellow', pantonecode: 'PANTONE Yellow C', rgbhexcode: '#FEDD00' },
    { id: 20, name: 'Chartreuse', pantonecode: 'PANTONE 382 C', rgbhexcode: '#C4D600' },
    { id: 21, name: 'Lime', pantonecode: 'PANTONE 376 C', rgbhexcode: '#84BD00' },
    { id: 22, name: 'Vivid Green', pantonecode: 'PANTONE 361 C', rgbhexcode: '#43B02A' },
    { id: 23, name: 'Forest Green', pantonecode: 'PANTONE 7739 C', rgbhexcode: '#34B233' },
    { id: 24, name: 'Emerald', pantonecode: 'PANTONE 347 C', rgbhexcode: '#009639' },
    { id: 25, name: 'Kelly Green', pantonecode: 'PANTONE 354 C', rgbhexcode: '#00843D' },
    { id: 26, name: 'Mint', pantonecode: 'PANTONE 332 C', rgbhexcode: '#99E9D6' },
    { id: 27, name: 'Teal', pantonecode: 'PANTONE 320 C', rgbhexcode: '#009CA6' },
    { id: 28, name: 'Cyan', pantonecode: 'PANTONE 312 C', rgbhexcode: '#00A9CE' },
    { id: 29, name: 'Azure', pantonecode: 'PANTONE 7461 C', rgbhexcode: '#007DBA' },
    { id: 30, name: 'Steel Blue', pantonecode: 'PANTONE 5405 C', rgbhexcode: '#4F7385' },
    { id: 31, name: 'Process Blue', pantonecode: 'PANTONE 285 C', rgbhexcode: '#0072CE' },
    { id: 32, name: 'Sky Blue', pantonecode: 'PANTONE 300 C', rgbhexcode: '#005EB8' },
    { id: 33, name: 'Royal Blue', pantonecode: 'PANTONE 2935 C', rgbhexcode: '#0057B8' },
    { id: 34, name: 'Cornflower', pantonecode: 'PANTONE 660 C', rgbhexcode: '#2C6EBC' },
    { id: 35, name: 'Indigo', pantonecode: 'PANTONE 2746 C', rgbhexcode: '#171C8F' },
    { id: 36, name: 'Deep Purple', pantonecode: 'PANTONE 2607 C', rgbhexcode: '#4E008E' },
    { id: 37, name: 'Orchid', pantonecode: 'PANTONE 2592 C', rgbhexcode: '#9B26B6' },
    { id: 38, name: 'Magenta', pantonecode: 'PANTONE 254 C', rgbhexcode: '#87189D' },
    { id: 39, name: 'Royal Purple', pantonecode: 'PANTONE Purple C', rgbhexcode: '#BB29BB' },
    { id: 40, name: 'Plum', pantonecode: 'PANTONE 513 C', rgbhexcode: '#93328E' },
    { id: 41, name: 'Jet Black', pantonecode: 'PANTONE Black 6 C', rgbhexcode: '#101820' },
    { id: 42, name: 'Onyx', pantonecode: 'PANTONE 419 C', rgbhexcode: '#212721' },
    { id: 43, name: 'Charcoal', pantonecode: 'PANTONE 426 C', rgbhexcode: '#25282A' },
    { id: 44, name: 'Slate', pantonecode: 'PANTONE 432 C', rgbhexcode: '#333F48' },
    { id: 45, name: 'Graphite', pantonecode: 'PANTONE 7540 C', rgbhexcode: '#4B4F54' },
    { id: 46, name: 'Silver', pantonecode: 'PANTONE 877 C', rgbhexcode: '#8A8D8F' },
    { id: 47, name: 'Cool Gray', pantonecode: 'PANTONE Cool Gray 7 C', rgbhexcode: '#97999B' },
    { id: 48, name: 'Taupe', pantonecode: 'PANTONE Warm Gray 4 C', rgbhexcode: '#B6ADA5' },
    { id: 49, name: 'Light Gray', pantonecode: 'PANTONE 421 C', rgbhexcode: '#C1C6C8' },
    { id: 50, name: 'Mist', pantonecode: 'PANTONE 428 C', rgbhexcode: '#D0D3D4' }
];

export const PANTONE_PRINT_METHOD = {
    printTypeID: 4297,
    name: 'Pantone Colors',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: 1,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 713,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 713,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: null,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: false,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#287fb9',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        // Unrestricted text resize: no min/max (or fixed/list) font-size bounds.
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: true,
        canPrintShadows: true,
        disableImageRotateUpload: null,
        disableImageRotateCliparts: null,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: 240,
        outputMirror: 0,
        // PANTONE (2) embedded colour with the coated Pantone palette; embedded PDF output enabled.
        embeddedColorType: 2,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 4,
        canStretchImages: true,
        canStretchTexts: true,
        embeddedPdf: true
    },
    printTypeFonts: [
        { printTypeID: 4297, fontFamilyID: 41, fontFamilyName: 'Leckerli One' },
        { printTypeID: 4297, fontFamilyID: 42, fontFamilyName: 'Amatic SC' },
        { printTypeID: 4297, fontFamilyID: 43, fontFamilyName: 'Kaushan Script' },
        { printTypeID: 4297, fontFamilyID: 44, fontFamilyName: 'Amiri' },
        { printTypeID: 4297, fontFamilyID: 45, fontFamilyName: 'Ramaraja' },
        { printTypeID: 4297, fontFamilyID: 46, fontFamilyName: 'Cairo' },
        { printTypeID: 4297, fontFamilyID: 47, fontFamilyName: 'Fondamento' },
        { printTypeID: 4297, fontFamilyID: 48, fontFamilyName: 'Gloria Hallelujah' },
        { printTypeID: 4297, fontFamilyID: 49, fontFamilyName: 'Indie Flower' },
        { printTypeID: 4297, fontFamilyID: 50, fontFamilyName: 'Arizonia' },
        { printTypeID: 4297, fontFamilyID: 51, fontFamilyName: 'Mada' },
        { printTypeID: 4297, fontFamilyID: 52, fontFamilyName: 'IM FELL English' },
        { printTypeID: 4297, fontFamilyID: 53, fontFamilyName: 'Berkshire Swash' },
        { printTypeID: 4297, fontFamilyID: 54, fontFamilyName: 'Permanent Marker' },
        { printTypeID: 4297, fontFamilyID: 55, fontFamilyName: 'Damion' },
        { printTypeID: 4297, fontFamilyID: 56, fontFamilyName: 'Adamina' },
        { printTypeID: 4297, fontFamilyID: 57, fontFamilyName: 'Rock Salt' },
        { printTypeID: 4297, fontFamilyID: 58, fontFamilyName: 'Pacifico' },
        { printTypeID: 4297, fontFamilyID: 59, fontFamilyName: 'Aladin' },
        { printTypeID: 4297, fontFamilyID: 60, fontFamilyName: 'Patrick Hand' },
        { printTypeID: 4297, fontFamilyID: 61, fontFamilyName: 'Cookie' },
        { printTypeID: 4297, fontFamilyID: 62, fontFamilyName: 'EB Garamond' },
        { printTypeID: 4297, fontFamilyID: 63, fontFamilyName: 'Merienda One' },
        { printTypeID: 4297, fontFamilyID: 64, fontFamilyName: 'Condiment' },
        { printTypeID: 4297, fontFamilyID: 291, fontFamilyName: 'Noto Sans' },
        { printTypeID: 4297, fontFamilyID: 2239, fontFamilyName: 'Alegreya Sans' },
        { printTypeID: 4297, fontFamilyID: 100009, fontFamilyName: 'Horrendous' },
        { printTypeID: 4297, fontFamilyID: 100016, fontFamilyName: 'Sour Gummy Expanded' },
        { printTypeID: 4297, fontFamilyID: 100023, fontFamilyName: 'cave' }
    ],
    fonts: [],
    // Pantone/CMYK mode (NOT the pantoneEnabled swatch picker): embeddedColorType PANTONE (2) + paletteTypeID 1
    // treat the palette as a Pantone-to-RGB conversion palette. Embedded PDF output is on and there is no colour
    // limit. pantoneEnabled stays false — the Pantone/CMYK conversion mode drives this method, not the picker.
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    maxColors: null,
    paletteID: null,
    paletteTypeID: 1,
    // Coated Pantone sample hexes used as the conversion palette (their codes are all "… C" = Coated).
    paletteColors: PANTONE_SAMPLE_COLORS.map((color) => color.rgbhexcode),
    // Labels for those swatches: the tone name on the primary line, the PANTONE code on the secondary one.
    // This is what sets the Pantone method apart from Screenprinting's house inks, which are named only.
    paletteColorNames: PANTONE_SAMPLE_COLORS.map((color) => ({
        hex: color.rgbhexcode,
        name: color.name,
        spotColorName: color.pantonecode
    })),
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: {
        printTypeID: 4297,
        presets: [5, 1, 4, 6, 2, 3, 7, 8],
        isImageEnabled: true,
        isTextEnabled: true,
        allowSpacingChange: true,
        allowOffsetChange: true
    },
    backgroundRemoverSettings: null
};

// CMYK Colors: same configuration as Pantone Colors (Pantone/CMYK Mode, no colour limit, embedded PDF,
// unrestricted text resize, text/image stretch, stroke, image filters) but in CMYK mode — embeddedColorType
// CMYK (1) + paletteTypeID 2 (CMYK) so the seed treats the palette as a CMYK-to-RGB conversion palette and
// auto-selects a CMYK coated mapping palette.
export const CMYK_PRINT_METHOD = {
    printTypeID: 1030478,
    name: 'CMYK Colors',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: 1,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1030454,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1030454,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: null,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#00ffff',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: true,
        canPrintShadows: true,
        disableImageRotateUpload: null,
        disableImageRotateCliparts: null,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#00ffff',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 10,
        canStretchImages: true,
        canStretchTexts: true,
        embeddedPdf: true
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    // No colour limit; CMYK conversion palette (paletteTypeID 2) as the CMYK-to-RGB mapping. These are the RGB
    // values of the process colours; the seed auto-selects a CMYK coated mapping palette in the editor.
    maxColors: null,
    paletteID: null,
    paletteTypeID: 2,
    paletteColors: ['#00ffff', '#ff00ff', '#ffff00', '#000000'],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};

/* Hidden from discovery (not shown in Carlo's set) - kept for restore:
// DTG (Direct-to-Garment): full-color inkjet printing straight onto fabric. Its strength is photographic,
// gradient-rich artwork, so it's the most PERMISSIVE method — no colour limit and no palette (maxColors
// null, paletteColors []), no special effect, every upload format incl. raster (JPG/PNG/social), with
// filters / gradient text / shadows enabled. Self-contained: no paletteID, so no account-palette coupling.
// printTypeID is synthetic (there was no source export to copy — swap it if you wire a real one).
export const DTG_PRINT_METHOD = {
    printTypeID: 1090916,
    name: 'DTG Printing',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1100879,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1100879,
        disableTextColors: false,
        allowGradientTextColors: true,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: 0,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#000000',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: true,
        canPrintShadows: true,
        disableImageRotateUpload: false,
        disableImageRotateCliparts: false,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 4,
        canStretchImages: true,
        canStretchTexts: true,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    maxColors: null,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: [],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};
*/

// UV printing: UV-cured inkjet on RIGID substrates (wood, metal, acrylic, glass, plastic, promo items).
// Full-color and photo-capable like DTG, so the customizer editing config mirrors it — no colour limit, no
// palette, no special effect, every upload format incl. raster, with filters / gradient text / shadows. Its
// real-world distinctions (white-ink underbase, gloss/varnish layers, rigid media) are PRODUCTION-side, not
// customizer editing restrictions, so they aren't encoded here: layeredPdf is a no-op the PM page forces to
// false, and the white→spot-colour swap is an account-scoped RGB-conversion list (kept out to stay
// self-contained). Self-contained: no paletteID. printTypeID is synthetic (no source export).
export const UV_PRINT_METHOD = {
    printTypeID: 1090917,
    name: 'UV Printing',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1100880,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1100880,
        disableTextColors: false,
        allowGradientTextColors: true,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: 0,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#000000',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: true,
        canPrintShadows: true,
        disableImageRotateUpload: false,
        disableImageRotateCliparts: false,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 4,
        canStretchImages: true,
        canStretchTexts: true,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    maxColors: null,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: [],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};

// Heat Transfer (HTV — heat-transfer vinyl): solid cut-vinyl colours heat-pressed onto the garment. A
// spot-colour method like Screenprinting — simple text/shapes, NO photos or gradients (each colour is a
// separate vinyl layer). So: a hardcoded palette of solid vinyl colours (rich picker + recolour via the
// sentinel-palette injection), NO raster uploads (vector cut paths only), no gradients / filters / shadows /
// effect, and splitColorFiles (one cut file per colour). Self-contained: no paletteID. Synthetic printTypeID.
export const HEAT_TRANSFER_PRINT_METHOD = {
    printTypeID: 1090918,
    name: 'Heat Transfer',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1100881,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1100881,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: false,
        uploadRestrictions: {
            isUserImageAllowed: false,
            isJpgAllowed: false,
            isPngAllowed: false,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: false,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: false,
            isInstagramAllowed: false,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: 0,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#000000',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: false,
        canPrintShadows: true,
        disableImageRotateUpload: false,
        disableImageRotateCliparts: false,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 2,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 5,
        canStretchImages: false,
        canStretchTexts: false,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    maxColors: 4,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: ['#ffffff', '#000000', '#c8102e', '#003da5', '#00843d', '#ffd100', '#ff6900', '#5f259f', '#e93cac', '#a2aaad'],
    splitColorFiles: true,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};

/**
 * Maps a DiscoveryModePanel printing-method button id to the raw print-type payload streamed to the
 * customizer. Buttons without an entry here send `null` (no override) until they're implemented.
 */
export const DISCOVERY_PRINTING_PAYLOADS: Record<string, object> = {
    'digital-print': DIGITAL_PRINT_PRINT_METHOD,
    screenprinting: SCREEN_PRINTING_PRINT_METHOD,
    monochromie: MONOCHROME_PRINT_METHOD,
    'cmyk-colors': CMYK_PRINT_METHOD,
    'limited-color-palette': LIMITED_COLOR_PALETTE_PRINT_METHOD,
    'pantone-colors': PANTONE_PRINT_METHOD,
    'repeated-patterns': REPEATED_PATTERNS_PRINT_METHOD,
    'ai-vectorizer': AI_VECTORIZER_PRINT_METHOD,
    'ai-background-remover': AI_BACKGROUND_REMOVER_PRINT_METHOD,
    'uv-printing': UV_PRINT_METHOD,
    'heat-transfer': HEAT_TRANSFER_PRINT_METHOD,
    'steel-engraving': STEEL_ENGRAVING_PRINT_METHOD,
    // Hidden from discovery - kept for restore (wood-engraving took this slot):
    // 'wood-printing': WOOD_PRINTING_PRINT_METHOD,
    'wood-engraving': WOOD_ENGRAVING_PRINT_METHOD,
    'glass-engraving': GLASS_ENGRAVING_PRINT_METHOD,
    pixelation: PIXELATION_PRINT_METHOD
};
